<template>
  <div style="margin-bottom: 200px">
    <Spin size="large" fix v-if="spinShow"></Spin>

    <Alert type="warning" show-icon v-else-if="!haveRole" style="width: 80%">
      这里什么都没有
      <template slot="desc"> 或许是因为你没有任何权限 </template>
    </Alert>

    <div v-else>
      <Row style="margin-bottom: 10px">
        <Button
          type="success"
          shape="circle"
          icon="md-add"
          @click="onClickAdd"
          v-if="isOwner"
          >创建 Vault</Button
        >
        <Button
          style="float: right"
          shape="circle"
          icon="md-refresh"
          @click="onClickRefresh"
        ></Button>
      </Row>

      <CollapseCard
        class="card"
        :name="`vault-${vaultIndex}`"
        v-for="(item, vaultIndex) in vaultList"
        :key="item.address"
        v-if="item.isRelated || item.isOwner"
        :toggled="vaultIndex === 0"
      >
        <div class="vault-title-wrapper" slot="title">
          <div class="vault-title">{{ item.name }}</div>
          <div class="edit-button" v-if="item.isOwner">
            <a href="#" @click.prevent.stop="onClickEditName(item)">
              <Icon type="md-create" color="#53545C" size="16" />
            </a>
          </div>
          <div class="address-wrapper">
            地址：
            <div class="address">{{ item.address }}</div>
            <div class="copy-button">
              <a href="#" @click.prevent.stop="doCopy(item.address)">
                <Icon type="md-copy" color="#53545C" size="16" />
              </a>
            </div>
          </div>
        </div>
        <div slot="content">
          <div class="strategy-wrapper">
            当前策略
            <div class="strategy">{{ item.strategyName }}</div>
            <Button
              type="warning"
              size="large"
              v-if="item.isOperator"
              @click="onClickEditStrategy(item)"
              >切换</Button
            >
          </div>
          <div class="overview" v-if="item.isHarvestor">
            <div class="title">Overview</div>
            <div class="overview-box-group">
              <div class="overview-box">
                <Spin fix v-if="investLoading"></Spin>

                <div class="overview-box-title">已抵押</div>
                <div
                  class="overview-box-text"
                  v-if="item.investedBalances"
                  v-for="(info, investTokenIndex) in item.investTokenInfos"
                >
                  {{
                    divDecimals(
                      item.investedBalances[investTokenIndex],
                      info.decimals
                    ).toNumber()
                  }}
                  {{ info.symbol }}
                </div>
                <Button
                  v-if="!investLoading && item.isHarvestor"
                  type="primary"
                  @click.stop.prevent="onClickRedeem(item)"
                  >赎回至Vault</Button
                >
              </div>
              <div class="overview-box">
                <Spin fix v-if="borrowLoading"></Spin>
                <div class="overview-box-title">已借出</div>
                <div
                  class="overview-box-text"
                  v-if="item.borrowedBalances"
                  v-for="(info, borrowTokenIndex) in item.borrowTokenInfos"
                >
                  {{
                    divDecimals(
                      item.borrowedBalances[borrowTokenIndex],
                      info.decimals
                    ).toNumber()
                  }}
                  {{ info.symbol }}
                </div>
              </div>
              <div class="overview-box">
                <Spin fix v-if="riskLoading"></Spin>
                <div class="overview-box-title" v-if="item.maxLeverage">
                  当前杠杆使用率<span>（max={{ item.maxLeverage }}%）</span>
                </div>
                <div class="leverage-wrapper" v-if="item.riskIndex">
                  <div class="leverage-text">
                    {{ getRisk(item.riskIndex) }}%
                  </div>
                  <Progress
                    :stroke-width="8"
                    stroke-color="#1BBE6B"
                    :percent="getRisk(item.riskIndex)"
                    hide-info
                  />
                </div>
              </div>
              <div class="overview-box">
                <Spin fix v-if="claimableLoading || rewardLoading"></Spin>
                <div class="overview-box-title">收益</div>
                <div
                  class="overview-box-text"
                  v-if="item.claimable && item.rewardTokenInfos"
                  v-for="(info, rewardTokenIndex) in item.rewardTokenInfos"
                >
                  {{
                    divDecimals(
                      item.claimable[rewardTokenIndex],
                      info.decimals
                    ).toNumber()
                  }}
                  {{ info.symbol }}
                </div>
                <Button
                  v-if="!claimableLoading && !rewardLoading && item.isHarvestor"
                  type="primary"
                  @click.stop.prevent="onClickClaim(item)"
                  >Claim</Button
                >
              </div>
            </div>
          </div>
          <CollapsePanel class="panel" name="asset-panel" v-if="item.isOwner">
            <div class="title" slot="title">存入资产</div>
            <div class="panel-content" slot="content">
              <Spin fix v-if="investLoading"></Spin>
              <div
                class="asset-card"
                v-if="item.investTokenInfos"
                v-for="(
                  investTokenInfo, investTokenIndex
                ) in item.investTokenInfos"
              >
                <div class="asset-title">{{ investTokenInfo.symbol }}</div>
                <div class="asset-content">
                  <div
                    class="deposit-box"
                    v-if="item.availableInvestTokenBalances"
                  >
                    <div class="balance-title">
                      钱包余额：{{
                        divDecimals(
                          item.availableInvestTokenBalances[investTokenIndex],
                          investTokenInfo.decimals
                        ).toNumber()
                      }}
                      {{ investTokenInfo.symbol }}
                    </div>
                    <div class="input-balance">
                      <input
                        type="text"
                        v-model="item[`depositInvestValue${investTokenIndex}`]"
                      />
                      <div
                        class="max-text"
                        v-if="
                          !!Number(
                            item.availableInvestTokenBalances[investTokenIndex]
                          )
                        "
                        @click="
                          onClickMaxDeposit(item, vaultIndex, investTokenIndex)
                        "
                      >
                        MAX
                      </div>
                      <div class="token-symbol">
                        {{ investTokenInfo.symbol }}
                      </div>
                    </div>
                    <div v-if="item.isOwner">
                      <Button
                        type="success"
                        @click="onClickDepositToAave(item, investTokenIndex)"
                        v-if="item.isInvestTokenApproveds[investTokenIndex]"
                        >存入Aave</Button
                      >
                      <Button
                        v-else
                        type="warning"
                        @click.stop.prevent="
                          onClickApprove(item, investTokenIndex)
                        "
                        >Approve</Button
                      >
                    </div>
                  </div>
                  <div class="withdraw-box" v-if="item.investTokenBalances">
                    <div class="balance-title">
                      可提余额：{{
                        divDecimals(
                          item.investTokenBalances[investTokenIndex],
                          investTokenInfo.decimals
                        ).toNumber()
                      }}
                      {{ investTokenInfo.symbol }}
                    </div>
                    <div class="input-balance">
                      <input
                        type="text"
                        v-model="item.withdrawInvestValues[investTokenIndex]"
                      />
                      <div
                        class="max-text"
                        v-if="
                          !!Number(item.investTokenBalances[investTokenIndex])
                        "
                        @click.stop.prevent="
                          onClickMaxWithdrawInvestToken(
                            item,
                            vaultIndex,
                            investTokenIndex
                          )
                        "
                      >
                        MAX
                      </div>
                      <div class="token-symbol">
                        {{ investTokenInfo.symbol }}
                      </div>
                    </div>
                    <Button
                      v-if="item.isOwner"
                      type="primary"
                      @click.stop.prevent="
                        onClickWithdrawInvestToken(
                          item,
                          vaultIndex,
                          investTokenIndex
                        )
                      "
                      >Withdraw</Button
                    >
                  </div>
                </div>
              </div>
              <div class="asset-card">
                <div class="asset-title">其他资产</div>
                <div class="asset-content">
                  <div class="deposit-box">
                    <div class="balance-title">
                      钱包余额：{{
                        divDecimals(
                          item.depositTokenBalance || 0,
                          item.depositTokenInfo
                            ? item.depositTokenInfo.decimals
                            : 1
                        ).toNumber()
                      }}
                      {{
                        item.depositTokenInfo
                          ? item.depositTokenInfo.symbol
                          : ""
                      }}
                    </div>
                    <SelectToken
                      v-model="item.depositToken"
                      :options="getTokenListExceptInvestTokens(item)"
                      :input="item.depositBorrowValue"
                      :tokenBalance="item.depositTokenBalance"
                      :tokenInfo="item.depositTokenInfo"
                      @on-select="onSelectDepositToken(item)"
                      @on-create="onCreateToken"
                      @on-click-max="
                        function (tokenSymbol) {
                          const idx = getTokenIdx(item, tokenSymbol);
                          onClickMaxDeposit(item, vaultIndex, idx);
                        }
                      "
                      @on-input="
                        function (value) {
                          item.depositBorrowValue = value;
                        }
                      "
                    />
                    <div v-if="item.isOwner">
                      <Button
                        type="success"
                        @click="onClickDeposit(item)"
                        v-if="
                          item.isBorrowTokenApproveds &&
                          item.isBorrowTokenApproveds[item.depositTokenIndex]
                        "
                      >
                        存入Vault
                      </Button>
                      <Button
                        v-else-if="item.depositToken"
                        type="warning"
                        @click.stop.prevent="
                          onClickApprove(item, item.depositTokenIndex + 10)
                        "
                        >Approve</Button
                      >
                    </div>
                  </div>
                  <div class="withdraw-box">
                    <div class="balance-title">
                      可提余额：{{
                        divDecimals(
                          item.withdrawTokenBalance || 0,
                          item.withdrawTokenInfo
                            ? item.withdrawTokenInfo.decimals
                            : 1
                        ).toNumber()
                      }}
                      {{
                        item.withdrawTokenInfo
                          ? item.withdrawTokenInfo.symbol
                          : ""
                      }}
                    </div>
                    <SelectToken
                      v-model="item.withdrawToken"
                      :options="getTokenListExceptInvestTokens(item)"
                      :input="item.withdrawValue"
                      :tokenBalance="item.withdrawTokenBalance"
                      :tokenInfo="item.withdrawTokenInfo"
                      @on-select="onSelectWithdrawToken(item, vaultIndex)"
                      @on-create="onCreateToken"
                      @on-click-max="onClickMaxWithdraw(item, vaultIndex)"
                      @on-input="
                        function (value) {
                          item.withdrawValue = value;
                        }
                      "
                    />
                    <Button
                      v-if="item.isOwner"
                      type="primary"
                      @click.stop.prevent="onClickWithdraw(item, vaultIndex)"
                      >Withdraw</Button
                    >
                  </div>
                </div>
              </div>
            </div>
          </CollapsePanel>
          <BorrowTokenPanel
            v-if="item.isOperator"
            :item="item"
            :refreshCount="refreshCount"
            :loading="borrowLoading"
            @cal-borrow="
              function () {
                onClickCalcBorrow(item, vaultIndex).then(function () {
                  refreshCount += 1;
                });
              }
            "
            @on-check="
              function () {
                onClickCheckBorrow(item, vaultIndex).then(function () {
                  refreshCount += 1;
                });
              }
            "
            @on-borrow="onClickEarn(item, vaultIndex)"
            @on-reset="onResetBorrow(item, vaultIndex)"
          />
          <RepayTokenPanel
            v-if="item.isHarvestor"
            :item="item"
            :refreshCount="refreshCount"
            :loading="borrowLoading"
            @cal-repay="
              function () {
                onClickCalcRepay(item, vaultIndex).then(function () {
                  refreshCount += 1;
                });
              }
            "
            @on-repay="onClickRepay(item, vaultIndex)"
            @on-reset="onResetRepay(item, vaultIndex)"
          />
          <Authentication
            :item="item"
            :editable="item.isOwner"
            @edit-owner="onClickEditOwner(item)"
            @accept-owner="onClickAcceptOwner(item.address)"
          />
        </div>
      </CollapseCard>

      <!-- <Row type="flex" justify="start" align="top">
        <Card style="width:48%;display: inline-block;" v-for="(item,index) in vaultList" :key="item.address" v-if="item.isRelated || isOwner">
          <div slot="title">{{item.name}}</div>
          <div slot="extra">
            <a href="#" @click.prevent="onClickEditName(item)" v-if="isOwner">
              <Icon type="md-create" /> 修改名称
            </a>
          </div>

          <Collapse simple value="1">
            <Panel name="1">
              基本操作
              <div slot="content">
                <Row class="opRow">
                  地址： {{item.address}}
                  <Button type="text" icon="md-copy" @click="doCopy(item.address)" />
                </Row>

                <Row class="opRow">
                  策略：
                  <Tag type="border" color="primary">{{item.strategyName}}</Tag>
                  <Button type="text" icon="md-create" @click="onClickEditStrategy(item)" v-if="item.isOwner" />
                </Row>

                <Row class="opRow">
                  充值到Vault：
                </Row>
                <Row type="flex" class="opRow" v-if="item.isOperator && item.investTokenInfos && item.availableInvestTokenBalances">
                  <Col>
                  <Input v-model="item.depositInvestValue0" placeholder="输入充币数量">
                  <span slot="append">{{item.investTokenInfos[0].symbol}}</span>
                  </Input>
                  </Col>
                  <Col style="margin-left: 8px;">
                  <Button @click="onClickMaxDeposit(item,index, 0)">Wallet: {{divDecimals(item.availableInvestTokenBalances[0],item.investTokenInfos[0].decimals).toNumber()}}
                  </Button>
                  </Col>
                  <Col style="margin-left: 8px">
                  <Button type="warning" @click="onClickDepositToAave(item, 0)" v-if="item.isInvestTokenApproveds[0]">Deposit</Button>
                  <Button type="warning" @click="onClickApprove(item, 0)" v-else>Approve</Button>
                  </Col>
                </Row>
                <Row type="flex" class="opRow" v-if="item.isOperator && item.investTokenInfos && item.availableInvestTokenBalances">
                  <Col>
                  <Input v-model="item.depositInvestValue1" placeholder="输入充币数量">
                  <span slot="append">{{item.investTokenInfos[1].symbol}}</span>
                  </Input>
                  </Col>
                  <Col style="margin-left: 8px;">
                  <Button @click="onClickMaxDeposit(item,index, 1)">Wallet: {{divDecimals(item.availableInvestTokenBalances[1],item.investTokenInfos[1].decimals).toNumber()}}
                  </Button>
                  </Col>
                  <Col style="margin-left: 8px">
                  <Button type="warning" @click="onClickDepositToAave(item, 1)" v-if="item.isInvestTokenApproveds[1]">Deposit</Button>
                  <Button type="warning" @click="onClickApprove(item, 1)" v-else>Approve</Button>
                  </Col>
                </Row>
                <Row type="flex" class="opRow" v-if="item.isOperator && item.borrowTokenInfos && item.availableBorrowTokenBalances">
                  <Col>
                  <Input v-model="item.depositBorrowValue0" placeholder="输入充币数量">
                  <span slot="append">{{item.borrowTokenInfos[0].symbol}}</span>
                  </Input>
                  </Col>
                  <Col style="margin-left: 8px;">
                  <Button @click="onClickMaxDeposit(item,index, 10)">Wallet: {{divDecimals(item.availableBorrowTokenBalances[0],item.borrowTokenInfos[0].decimals).toNumber()}}
                  </Button>
                  </Col>
                  <Col style="margin-left: 8px">
                  <Button type="warning" @click="onClickDeposit(item, 0)" v-if="item.isBorrowTokenApproveds[0]">Deposit</Button>
                  <Button type="warning" @click="onClickApprove(item, 10)" v-else>Approve</Button>
                  </Col>
                </Row>
                <Row type="flex" class="opRow" v-if="item.isOperator && item.borrowTokenInfos && item.availableBorrowTokenBalances">
                  <Col>
                  <Input v-model="item.depositBorrowValue1" placeholder="输入充币数量">
                  <span slot="append">{{item.borrowTokenInfos[1].symbol}}</span>
                  </Input>
                  </Col>
                  <Col style="margin-left: 8px;">
                  <Button @click="onClickMaxDeposit(item,index, 11)">Wallet: {{divDecimals(item.availableBorrowTokenBalances[1],item.borrowTokenInfos[1].decimals).toNumber()}}
                  </Button>
                  </Col>
                  <Col style="margin-left: 8px">
                  <Button type="warning" @click="onClickDeposit(item, 1)" v-if="item.isBorrowTokenApproveds[1]">Deposit</Button>
                  <Button type="warning" @click="onClickApprove(item, 11)" v-else>Approve</Button>
                  </Col>
                </Row>
                <Row type="flex" class="opRow" v-if="item.isOperator && item.borrowTokenInfos && item.availableBorrowTokenBalances">
                  <Col>
                  <Input v-model="item.depositBorrowValue2" placeholder="输入充币数量">
                  <span slot="append">{{item.borrowTokenInfos[2].symbol}}</span>
                  </Input>
                  </Col>
                  <Col style="margin-left: 8px;">
                  <Button @click="onClickMaxDeposit(item,index, 12)">Wallet: {{divDecimals(item.availableBorrowTokenBalances[2],item.borrowTokenInfos[2].decimals).toNumber()}}
                  </Button>
                  </Col>
                  <Col style="margin-left: 8px">
                  <Button type="warning" @click="onClickDeposit(item, 2)" v-if="item.isBorrowTokenApproveds[2]">Deposit</Button>
                  <Button type="warning" @click="onClickApprove(item, 12)" v-else>Approve</Button>
                  </Col>
                </Row>

                <Row class="opRow">
                  Vault资产状况：
                </Row>
                <Row type="flex" class="opRow" v-if="item.isOperator && item.investTokenInfos && item.investTokenBalances">
                  <Col style="margin-left: 8px;">
                  <Tag type="border" color="primary">{{item.investTokenInfos[0].symbol}}: {{divDecimals(item.investTokenBalances[0],item.investTokenInfos[0].decimals).toNumber()}}
                  </Tag>
                  </Col>
                  <Col style="margin-left: 8px;">
                  <Tag type="border" color="primary">{{item.investTokenInfos[1].symbol}}: {{divDecimals(item.investTokenBalances[1],item.investTokenInfos[1].decimals).toNumber()}}
                  </Tag>
                  </Col>
                </Row>
                <Row type="flex" class="opRow" v-if="item.isOperator && item.borrowTokenInfos && item.borrowTokenBalances">
                  <Col style="margin-left: 8px;">
                  <Tag type="border" color="primary">{{item.borrowTokenInfos[0].symbol}}: {{divDecimals(item.borrowTokenBalances[0],item.borrowTokenInfos[0].decimals).toNumber()}}
                  </Tag>
                  </Col>
                  <Col style="margin-left: 8px;">
                  <Tag type="border" color="primary">{{item.borrowTokenInfos[1].symbol}}: {{divDecimals(item.borrowTokenBalances[1],item.borrowTokenInfos[1].decimals).toNumber()}}
                  </Tag>
                  </Col>
                  <Col style="margin-left: 8px;">
                  <Tag type="border" color="primary">{{item.borrowTokenInfos[2].symbol}}: {{divDecimals(item.borrowTokenBalances[2],item.borrowTokenInfos[2].decimals).toNumber()}}
                  </Tag>
                  </Col>
                </Row>
                <Row type="flex" class="opRow" v-if="item.isOperator && item.rewardTokenInfos && item.rewardTokenBalances">
                  <Col style="margin-left: 8px;">
                  <Tag type="border" color="primary">{{item.rewardTokenInfos[0].symbol}}: {{divDecimals(item.rewardTokenBalances[0],item.rewardTokenInfos[0].decimals).toNumber()}}
                  </Tag>
                  </Col>
                  <Col style="margin-left: 8px;">
                  <Tag type="border" color="primary">{{item.rewardTokenInfos[1].symbol}}: {{divDecimals(item.rewardTokenBalances[1],item.rewardTokenInfos[1].decimals).toNumber()}}
                  </Tag>
                  </Col>
                </Row>

                <Row class="opRow">
                  投入Strategy：
                </Row>
                <Row type="flex" class="opRow" v-if="item.isOperator && item.borrowTokenInfos && item.borrowTokenBalances">
                  <Col>
                  <Input v-model="item.borrowTokenRatio" placeholder="输入借币比例(1-80)" />
                  </Input>
                  </Col>
                  <Col style="margin-left: 8px">
                  <Button type="warning" @click="onClickCalcBorrow(item, index)">Calc</Button>
                  </Col>
                </Row>
                <Row class="opRow" v-if="item.borrowInfo">
                  {{item.borrowInfo}}
                </Row>
                <Row type="flex" class="opRow" v-if="item.isOperator && item.borrowTokenInfos && item.borrowTokenBalances">
                  <Col>
                  <Input v-model="item.borrowTokenValue0" placeholder="输入借币数量">
                  <span slot="append">{{item.borrowTokenInfos[0].symbol}}</span>
                  </Input>
                  </Col>
                  <Col>
                  <Input v-model="item.borrowTokenValue1" placeholder="输入借币数量">
                  <span slot="append">{{item.borrowTokenInfos[1].symbol}}</span>
                  </Input>
                  </Col>
                  <Col>
                  <Input v-model="item.borrowTokenValue2" placeholder="输入借币数量">
                  <span slot="append">{{item.borrowTokenInfos[2].symbol}}</span>
                  </Input>
                  </Col>
                  <Col style="margin-left: 8px">
                  <Button type="warning" @click="onClickCheckBorrow(item, index)">Check</Button>
                  </Col>
                  <Col style="margin-left: 8px">
                  <Button type="warning" @click="onClickEarn(item)">Earn</Button>
                  </Col>
                </Row>

                <Row class="opRow">
                  Strategy资产状况：
                </Row>
                <Row type="flex" class="opRow" v-if="item.isOperator">
                  <Col style="margin-left: 8px;" v-if="item.riskIndex">
                  <Tag type="border" color="primary">Risk Index: {{divDecimals(item.riskIndex, 6).toNumber()}}
                  </Tag>
                  </Col>
                </Row>
                <Row type="flex" class="opRow" v-if="item.isOperator && item.investedBalances">
                  <Col style="margin-left: 8px;">
                  <Tag type="border" color="primary">投入Aave资产: </Tag>
                  </Col>
                  <Col style="margin-left: 8px;">
                  <Tag type="border" color="primary">{{item.investTokenInfos[0].symbol}}: {{divDecimals(item.investedBalances[0],item.investTokenInfos[0].decimals).toNumber()}}
                  </Tag>
                  </Col>
                  <Col style="margin-left: 8px;">
                  <Tag type="border" color="primary">{{item.investTokenInfos[1].symbol}}: {{divDecimals(item.investedBalances[1],item.investTokenInfos[1].decimals).toNumber()}}
                  </Tag>
                  </Col>
                </Row>
                <Row type="flex" class="opRow" v-if="item.isOperator && item.borrowedBalances">
                  <Col style="margin-left: 8px;">
                  <Tag type="border" color="primary">借出Aave资产: </Tag>
                  </Col>
                  <Col style="margin-left: 8px;">
                  <Tag type="border" color="primary">{{item.borrowTokenInfos[0].symbol}}: {{divDecimals(item.borrowedBalances[0],item.borrowTokenInfos[0].decimals).toNumber()}}
                  </Tag>
                  </Col>
                  <Col style="margin-left: 8px;">
                  <Tag type="border" color="primary">{{item.borrowTokenInfos[1].symbol}}: {{divDecimals(item.borrowedBalances[1],item.borrowTokenInfos[1].decimals).toNumber()}}
                  </Tag>
                  </Col>
                  <Col style="margin-left: 8px;">
                  <Tag type="border" color="primary">{{item.borrowTokenInfos[2].symbol}}: {{divDecimals(item.borrowedBalances[2],item.borrowTokenInfos[2].decimals).toNumber()}}
                  </Tag>
                  </Col>
                </Row>

                <Row class="opRow">
                  从Strategy赎回收益：
                </Row>
                <Row type="flex" class="opRow" v-if="item.isHarvestor">
                  <Col style="margin-left: 8px;" v-if="item.rewardTokenInfos && item.claimable">
                  <Tag type="border" color="primary">{{item.rewardTokenInfos[0].symbol}}: {{divDecimals(item.claimable[0],item.rewardTokenInfos[0].decimals).toNumber()}}
                  </Tag>
                  </Col>
                  <Col style="margin-left: 8px;" v-if="item.rewardTokenInfos && item.claimable">
                  <Tag type="border" color="primary">{{item.rewardTokenInfos[1].symbol}}: {{divDecimals(item.claimable[1],item.rewardTokenInfos[1].decimals).toNumber()}}
                  </Tag>
                  </Col>
                  <Col style="margin-left: 8px">
                  <Button type="success" @click="onClickClaim(item)">Claim</Button>
                  </Col>
                </Row>

                <Row class="opRow">
                  从Strategy撤回资金：
                </Row>
                <Row type="flex" class="opRow" v-if="item.isHarvestor">
                  <Col>
                  <Input v-model="item.repayRatio" placeholder="输入撤回比例(1~100)"></Input>
                  </Col>
                  <Col style="margin-left: 8px">
                  <Button type="success" @click="onClickCalcRepay(item, index)">Calc</Button>
                  </col>
                  <Col style="margin-left: 8px">
                  <Button type="success" @click="onClickRepay(item)">Repay borrow</Button>
                  </col>
                  <Col style="margin-left: 8px">
                  <Button type="success" @click="onClickRedeem(item)">Redeem invest</Button>
                  </col>
                </Row>
                <Row class="opRow" v-if="item.repayInfo">
                  {{item.repayInfo}}
                </Row>
                <Row type="flex" class="opRow" v-if="item.isHarvestor && item.borrowTokenInfos && item.repayTokenValue0">
                  <Col>
                  <Input v-model="item.repayTokenValue0">
                  <span slot="append">{{item.borrowTokenInfos[0].symbol}}</span>
                  </Input>
                  </Col>
                  <Col>
                  <Input v-model="item.repayTokenValue1">
                  <span slot="append">{{item.borrowTokenInfos[1].symbol}}</span>
                  </Input>
                  </Col>
                  <Col>
                  <Input v-model="item.repayTokenValue2">
                    <span slot="append">{{item.borrowTokenInfos[2].symbol}}</span>
                  </Input>
                  </Col>
                </Row>

                <Row class="opRow">
                  从Vault取回资金：
                </Row>
                <Row class="opRow" type="flex" v-if="isOwner">
                  <Col span="8" style="margin-left: 8px">
                  <Input v-model="item.withdrawValue" placeholder="输入提币数量">
                  </Input>
                  </Col>

                  <Col span="4">
                  <Select v-model="item.withdrawToken" filterable allow-create placeholder="选择币种" @on-create="onCreateToken" @on-change="onSelectWithdrawToken(item,index)">
                    <Option v-for="token in tokenList" :value="token.address" :key="token.address">
                      {{ token.symbol}}
                    </Option>
                  </Select>
                  </Col>

                  <Col style="margin-left: 8px;" v-if="item.withdrawToken && item.withdrawTokenInfo">
                  <Button @click="onClickMaxWithdraw(item,index)">
                    Max: {{divDecimals(item.withdrawTokenBalance,item.withdrawTokenInfo.decimals).toNumber()}}
                  </Button>
                  </Col>
                  <Col span="6" style="margin-left: 8px">
                  <Button type="error" @click="onClickWithdraw(item,index)">
                    Withdraw
                  </Button>
                  </Col>

                </Row>

              </div>
            </Panel>
            <Panel name="2">
              权限管理
              <div slot="content">
                <Row class="opRow">
                  Owner：{{item.owner}}
                  <Button type="text" icon="md-create" @click="onClickEditOwner(item)" v-if="item.isOwner" />

                </Row>

                <Row class="opRow" v-if="item.pendingOwner!=='0x0000000000000000000000000000000000000000'">
                  待接受 Owner：{{item.pendingOwner}}
                  <Button v-if="myAddr===item.pendingOwner" type="success" style="margin-left: 8px" @click="onClickAcceptOwner(item.address)">接受成为 Owner
                  </Button>
                </Row>

                <AccessControl :editable="item.isOwner" :vaultAddress="item.address" />

              </div>
            </Panel>
          </Collapse>

        </Card>
      </Row> -->
    </div>

    <Modal
      v-if=""
      v-model="modalShow"
      :title="modalTitle"
      :loading="modalLoading"
      @on-ok="modalDone"
    >
      <Form
        ref="modalForm"
        :model="modalForm"
        :label-width="70"
        :rules="ruleValidate"
      >
        <FormItem
          label="名称"
          prop="name"
          v-if="modalType === 'create' || modalType === 'vaultName'"
        >
          <Input v-model="modalForm.name" placeholder="输入金库名称"></Input>
        </FormItem>
        <FormItem label="Owner" prop="owner" v-if="modalType === 'owner'">
          <Input
            v-model="modalForm.owner"
            placeholder="输入提议的 Owner 地址"
          ></Input>
        </FormItem>

        <FormItem
          label="策略"
          prop="strategy"
          v-if="modalType === 'create' || modalType === 'strategy'"
        >
          <Select
            v-model="modalForm.strategy"
            filterable
            :placeholder="selectPlaceholder"
          >
            <Option
              v-for="(option, index) in selectList"
              :value="option.address"
              :key="index"
            >
              {{ option.name }}
            </Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import TagList from "@/components/common/TagList";
import CollapseCard from "@/components/common/CollapseCard";
import CollapsePanel from "@/components/common/CollapsePanel";
import SelectToken from "@/components/vault/SelectToken";
import BorrowTokenPanel from "./components/BorrowTokenPanel";
import RepayTokenPanel from "./components/RepayTokenPanel";
import Authentication from "./components/Authentication";
import { Strategy, Vault } from "@/config/abis";
import Store from "@/utils/store";
import contract from "@/utils/contracts/common";
import tools from "@/utils/contracts/tools";
import { waitForTx } from "@/utils/tx";
import { MaxUint256 } from "@ethersproject/constants";
import { BigNumber } from "bignumber.js";
import { isNumber } from "util";

export default {
  name: "vault_manager",
  components: {
    TagList,
    CollapseCard,
    CollapsePanel,
    SelectToken,
    BorrowTokenPanel,
    RepayTokenPanel,
    Authentication,
  },
  data() {
    return {
      newStrategyAddr: "",
      modalShow: false,
      modalTitle: "",
      vaultList: [],
      ruleValidate: {
        name: [
          {
            required: true,
            message: "The name cannot be empty",
            trigger: "blur",
          },
        ],
        strategy: [
          {
            required: true,
            message: "The strategy cannot be empty",
            trigger: "blur",
          },
        ],
      },
      selectLoading: false,
      select: null,
      selectList: [],
      selectPlaceholder: "",
      modalType: "",
      modalForm: {},
      modalLoading: true,
      custodyIndex: null,
      spinShow: false,
      isOwner: window.isOwner,
      myAddr: window.currAddress,
      tokenList: [],
      haveRole: isOwner,
      refreshCount: 0,
      investLoading: false,
      borrowLoading: false,
      riskLoading: false,
      claimableLoading: false,
      rewardLoading: false,
    };
  },
  async mounted() {
    await this.onClickRefresh();
    this.custodyIndex = contract.getCustodyIndex();
  },

  computed: {},

  methods: {
    divDecimals: tools.divDecimals,
    mulDecimals: tools.mulDecimals,

    getTokenListExceptInvestTokens(item) {
      return this.tokenList.filter((tokenInfo) => {
        return !(item.investTokenInfos || []).find((investTokenInfo) => {
          return investTokenInfo.symbol === tokenInfo.symbol;
        });
      });
    },

    getRisk(riskIndex = 0) {
      const risk = Number(this.divDecimals(riskIndex, 6).toFixed(2));
      return risk;
    },

    onSelectDepositToken(item) {
      const index = item.borrowTokens.findIndex((borrowToken) => {
        return borrowToken === item.depositToken;
      });

      item.depositTokenBalance = item.availableBorrowTokenBalances[index] || 0;
      item.depositTokenInfo = item.borrowTokenInfos[index] || null;
      item.depositTokenIndex = index;
    },

    async onClickMaxWithdrawInvestToken(item, vaultIndex, investTokenIndex) {
      item.withdrawInvestToken = item.investTokens[investTokenIndex];
      await this.onSelectWithdrawInvestToken(
        item,
        vaultIndex,
        investTokenIndex
      );
      this.calMaxWithdrawInvestTokenValue(item, vaultIndex, investTokenIndex);
    },

    async getVaultMaxLeverage(item, index) {
      const vault = contract.getVault(item.address);

      vault.methods
        .LEVERAGE_MAX()
        .call()
        .then((leveragePrecision) => {
          vault.methods
            .leverage()
            .call()
            .then((maxLeverage) => {
              item.maxLeverage = new BigNumber(maxLeverage)
                .dividedBy(new BigNumber(leveragePrecision))
                .multipliedBy(100)
                .toNumber();
              this.$set(this.vaultList, index, item);
            });
        });
    },

    onResetBorrow(item, index) {
      item.currentBorrowLeverage = 0;
      item.maxBorrowLeverage = 0;
      item.borrowInfo = "";
      item.borrowSlippageTitle = "";
      item.borrowSlippage = 0;
      (item.borrowTokenInfos || []).forEach((_, index) => {
        item[`borrowTokenValue${index}`] = "";
      });

      this.$set(this.vaultList, item, index);
    },

    onResetRepay(item, index) {
      item.currentRepayLeverage = 0;
      item.maxRepayLeverage = 0;
      item.repayInfo = "";
      (item.borrowTokenInfos || []).forEach((_, index) => {
        item[`repayTokenValue${index}`] = "";
      });

      this.$set(this.vaultList, item, index);
    },

    doCopy(txt) {
      // if(txt)
      this.$copyText(txt).then(
        (e) => {
          this.$Message.success("已复制到粘贴板");
        },
        function (e) {
          this.$Message.error("复制失败");
        }
      );
    },
    onClickEditStrategy(item) {
      this.modalTitle = `设置【${item.name}】的策略`;
      this.selectPlaceholder = "请选择";
      this.modalType = "strategy";
      this.selectList = contract.loadStrategiesFromCache();
      this.modalForm = {};
      this.modalForm.strategy = item.strategyAddr;
      this.modalForm.vaultAddr = item.address;
      this.modalShow = true;

      contract.loadStrategies();
    },
    onClickEditName(item) {
      this.modalTitle = `设置【${item.name}】的名称`;
      this.modalType = "vaultName";
      this.modalForm = {};
      this.modalForm.name = item.name;
      this.modalForm.vaultAddr = item.address;
      this.modalShow = true;
    },
    onClickAdd() {
      this.modalTitle = `创建金库`;
      this.selectPlaceholder = "请选择";
      this.modalForm = {};
      this.modalType = "create";
      this.selectList = contract.loadStrategiesFromCache();
      this.modalShow = true;

      contract.loadStrategies();
    },
    onClickEditOwner(item) {
      this.modalTitle = `移交【${item.name}】的 Owner`;
      this.modalType = "owner";
      this.modalForm = {};
      this.modalForm.owner = item.owner;
      this.modalForm.vaultAddr = item.address;
      this.modalShow = true;
    },
    onClickApprove(item, tokenIndex) {
      if (!item.address) return;
      if (tokenIndex < 0) return;
      let erc20;
      if (tokenIndex < 10) {
        erc20 = contract.getERC20(item.investTokens[tokenIndex]);
      } else if (tokenIndex < 20) {
        erc20 = contract.getERC20(item.borrowTokens[tokenIndex - 10]);
      }
      erc20.methods
        .approve(item.address, MaxUint256)
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt();
          });
        });
    },
    onClickDepositToAave(item, tokenIndex) {
      if (!item.address) return;
      if (tokenIndex < 0) return;
      let vault = contract.getStrategy(item.address);
      let tokenAddress = item.investTokens[tokenIndex];
      let tokenAmount =
        tokenIndex == 0 ? item.depositInvestValue0 : item.depositInvestValue1;
      if (!tokenAmount) return;
      let value = this.mulDecimals(
        tokenAmount,
        item.investTokenInfos[tokenIndex].decimals
      );
      if (value == 0) return;
      vault.methods
        .depositToAave(tokenAddress, value.toString())
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt();
          });
        });
    },
    onClickDeposit(item, tokenIndex) {
      if (!isNumber(tokenIndex)) {
        tokenIndex = item.depositTokenIndex;
      }

      if (!item.address) return;
      if (tokenIndex < 0) return;
      let vault = contract.getStrategy(item.address);
      let tokenAddress = item.borrowTokens[tokenIndex];
      // let tokenAmount =
      //   tokenIndex == 0
      //     ? item.depositBorrowValue0
      //     : tokenIndex == 1
      //     ? item.depositBorrowValue1
      //     : item.depositBorrowValue2;

      let tokenAmount = item.depositBorrowValue;
      if (!tokenAmount) return;
      let value = this.mulDecimals(
        tokenAmount,
        item.borrowTokenInfos[tokenIndex].decimals
      );
      if (value == 0) return;
      vault.methods
        .deposit(tokenAddress, value.toString())
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt();
          });
        });
    },
    async onClickCalcBorrow(item, index) {
      item.borrowInfo = "";
      if (!item.address || !item.borrowTokenRatio) return;
      let vault = contract.getStrategy(item.address);
      let ret = await vault.methods
        .borrowableAmounts(item.borrowTokenRatio.toString())
        .call({ from: window.currAddress });
      let amounts = ret["0"];
      item.borrowTokenValue0 = this.divDecimals(
        amounts[0],
        item.borrowTokenInfos[0].decimals
      ).toString();
      item.borrowTokenValue1 = this.divDecimals(
        amounts[1],
        item.borrowTokenInfos[1].decimals
      ).toString();
      item.borrowTokenValue2 = this.divDecimals(
        amounts[2],
        item.borrowTokenInfos[2].decimals
      ).toString();
      let currentLeverage = this.divDecimals(ret["1"], 6).toNumber();
      let maxLeverage = this.divDecimals(ret["2"], 6).toNumber();
      item.borrowInfo =
        "  当前杠杆： " +
        currentLeverage +
        "%， 最大允许杠杆： " +
        maxLeverage +
        "%";
      item.currentBorrowLeverage = currentLeverage;
      item.maxBorrowLeverage = maxLeverage;
      this.$set(this.vaultList, index, item);
    },
    async onClickCheckBorrow(item, index) {
      item.borrowInfo = "";
      item.expectedMintAmount = "";
      if (!item.address) return;
      let vault = contract.getStrategy(item.address);
      let value0 = this.mulDecimals(
        item.borrowTokenValue0,
        item.borrowTokenInfos[0].decimals
      );
      let value1 = this.mulDecimals(
        item.borrowTokenValue1,
        item.borrowTokenInfos[1].decimals
      );
      let value2 = this.mulDecimals(
        item.borrowTokenValue2,
        item.borrowTokenInfos[2].decimals
      );

      let ret = await vault.methods
        .checkBorrow([value0.toString(), value1.toString(), value2.toString()])
        .call({ from: window.currAddress });
      let currentLeverage = this.divDecimals(ret["0"], 6).toNumber();
      let maxLeverage = this.divDecimals(ret["1"], 6).toNumber();
      item.expectedMintAmount = ret["2"];

      let lpAmount = this.divDecimals(ret["2"], 18);
      let lpPrice = this.divDecimals(ret["3"], 18);
      let amountDeposit =
        parseFloat(item.borrowTokenValue0) +
        parseFloat(item.borrowTokenValue1) +
        parseFloat(item.borrowTokenValue2);
      let amountWithdrawable = parseFloat(lpAmount) * parseFloat(lpPrice);
      let slippage =
        ((amountWithdrawable - amountDeposit) * 100) / amountDeposit;
      let slippageTitle = slippage < 0 ? "滑点" : "奖励";
      item.borrowInfo =
        "  Borrow后杠杆： " +
        currentLeverage +
        "%， 最大杠杆： " +
        maxLeverage +
        "%， " +
        slippageTitle +
        "： " +
        Math.abs(slippage) +
        "%";

      item.currentBorrowLeverage = currentLeverage;
      item.maxBorrowLeverage = maxLeverage;
      item.borrowSlippage = Math.abs(slippage);
      item.borrowSlippageTitle = slippageTitle;

      console.log(item);

      this.$set(this.vaultList, index, item);
    },
    onClickEarn(item) {
      if (!item.address || !item.expectedMintAmount) return;
      let vault = contract.getStrategy(item.address);
      let value0 = this.mulDecimals(
        item.borrowTokenValue0,
        item.borrowTokenInfos[0].decimals
      );
      let value1 = this.mulDecimals(
        item.borrowTokenValue1,
        item.borrowTokenInfos[1].decimals
      );
      let value2 = this.mulDecimals(
        item.borrowTokenValue2,
        item.borrowTokenInfos[2].decimals
      );

      vault.methods
        .earn(
          [value0.toString(), value1.toString(), value2.toString()],
          item.expectedMintAmount
        )
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt();
          });
        });
    },
    onClickClaim(item) {
      let vault = contract.getStrategy(item.address);
      vault.methods
        .claim()
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt();
          });
        });
    },
    async onClickCalcRepay(item, index) {
      item.repayInfo = "";
      if (!item.address || !item.repayRatio) return;
      let vault = contract.getStrategy(item.address);
      let ret = await vault.methods
        .repayableableAmounts(item.repayRatio.toString())
        .call({ from: window.currAddress });
      let amounts = ret["0"];
      item.repayTokenValue0 = this.divDecimals(
        amounts[0],
        item.borrowTokenInfos[0].decimals
      ).toString();
      item.repayTokenValue1 = this.divDecimals(
        amounts[1],
        item.borrowTokenInfos[1].decimals
      ).toString();
      item.repayTokenValue2 = this.divDecimals(
        amounts[2],
        item.borrowTokenInfos[2].decimals
      ).toString();
      let currentLeverage = this.divDecimals(ret["1"], 6).toNumber();
      let maxLeverage = this.divDecimals(ret["2"], 6).toNumber();
      item.repayInfo =
        "  Repay后杠杆： " +
        currentLeverage +
        "%， 最大允许杠杆： " +
        maxLeverage +
        "%";

      item.currentRepayLeverage = currentLeverage;
      item.maxRepayLeverage = maxLeverage;

      this.$set(this.vaultList, index, item);
    },
    onClickRepay(item) {
      if (!item.repayRatio) return;
      let ratio = parseInt(item.repayRatio);
      if (ratio < 0 || ratio > 100) return;
      let vault = contract.getStrategy(item.address);
      vault.methods
        .repayAave(ratio.toString())
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt();
          });
        });
    },
    onClickRedeem(item) {
      let vault = contract.getStrategy(item.address);
      vault.methods
        .redeemAave()
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt();
          });
        });
    },
    async onClickWithdrawInvestToken(item, vaultIndex, investTokenIndex) {
      item.withdrawInvestToken = item.investTokens[investTokenIndex];
      await this.onSelectWithdrawInvestToken(
        item,
        vaultIndex,
        investTokenIndex
      );

      if (!item.address || !item.withdrawInvestValues[investTokenIndex]) return;
      let vault = contract.getVault(item.address);
      let value = this.mulDecimals(
        item.withdrawInvestValues[investTokenIndex],
        item.withdrawInvestTokenInfo.decimals
      );
      vault.methods
        .withdraw(item.withdrawInvestToken, value.toString())
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) {
              this.loadVaultSt();
            }
          });
        });
    },

    onClickWithdraw(item, index) {
      if (!item.address || !item.withdrawValue) return;
      let vault = contract.getVault(item.address);
      let value = this.mulDecimals(
        item.withdrawValue,
        item.withdrawTokenInfo.decimals
      );
      vault.methods
        .withdraw(item.withdrawToken, value.toString())
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) {
              this.loadVaultSt();
              this.onSelectWithdrawToken(item, index);
            }
          });
        });
    },

    getTokenIdx(item, tokenSymbol) {
      const index = item.borrowTokenInfos.findIndex(
        (info) => info.symbol === tokenSymbol
      );
      return index === -1 ? -1 : 10 + index;
    },

    onClickMaxDeposit(item, index, idx) {
      if (idx == 0) {
        item.depositInvestValue0 = this.divDecimals(
          item.availableInvestTokenBalances[0],
          item.investTokenInfos[0].decimals
        ).toString();
      } else if (idx == 1) {
        item.depositInvestValue1 = this.divDecimals(
          item.availableInvestTokenBalances[1],
          item.investTokenInfos[1].decimals
        ).toString();
      } else if (idx == 10) {
        item.depositBorrowValue = this.divDecimals(
          item.availableBorrowTokenBalances[0],
          item.borrowTokenInfos[0].decimals
        ).toString();
      } else if (idx == 11) {
        item.depositBorrowValue = this.divDecimals(
          item.availableBorrowTokenBalances[1],
          item.borrowTokenInfos[1].decimals
        ).toString();
      } else if (idx == 12) {
        item.depositBorrowValue = this.divDecimals(
          item.availableBorrowTokenBalances[2],
          item.borrowTokenInfos[1].decimals
        ).toString();
      }
      this.$set(this.vaultList, index, item);
    },
    calMaxWithdrawInvestTokenValue(item, vaultIndex, investTokenIndex) {
      item.withdrawInvestValues[investTokenIndex] = this.divDecimals(
        item.withdrawInvestTokenBalance,
        item.withdrawInvestTokenInfo.decimals
      )
        .plus(1)
        .toString();

      this.$set(
        item.withdrawInvestValues,
        investTokenIndex,
        item.withdrawInvestValues[investTokenIndex]
      );
      this.$set(this.vaultList, vaultIndex, item);
    },

    onClickMaxWithdraw(item, index) {
      item.withdrawValue = this.divDecimals(
        item.withdrawTokenBalance,
        item.withdrawTokenInfo.decimals
      )
        .plus(1)
        .toString();
      this.$set(this.vaultList, index, item);
    },
    async onSelectWithdrawToken(item, index) {
      let token = await contract.getERC20Info(item.withdrawToken);
      let tokenBalance = await contract.getERC20BalanceOf(
        item.withdrawToken,
        item.address
      );
      item.withdrawTokenInfo = token;
      item.withdrawTokenBalance = tokenBalance;
      this.$set(this.vaultList, index, item);
    },

    async onSelectWithdrawInvestToken(item, vaultIndex, investTokenIndex) {
      let token = await contract.getERC20Info(item.withdrawInvestToken);
      let tokenBalance = await contract.getERC20BalanceOf(
        item.withdrawInvestToken,
        item.address
      );
      item.withdrawInvestTokenInfo = token;
      item.withdrawInvestTokenBalance = tokenBalance;
      this.$set(this.vaultList, vaultIndex, item);
    },
    modalDone() {
      this.$refs["modalForm"].validate((valid) => {
        if (valid) {
          if (this.modalType === "create") {
            this.createVault(this.modalForm.strategy, this.modalForm.name);
          } else if (this.modalType === "strategy") {
            this.editStrategy(
              this.modalForm.strategy,
              this.modalForm.vaultAddr
            );
          } else if (this.modalType === "vaultName") {
            this.editVaultName(this.modalForm.name, this.modalForm.vaultAddr);
          } else if (this.modalType === "owner") {
            this.modalForm.owner = tools.checkNoticeAddressValid(
              this,
              this.modalForm.owner
            );
            if (!this.modalForm.owner) {
              this.modalLoading = false;
              return;
            }
            this.editVaultOwner(this.modalForm.owner, this.modalForm.vaultAddr);
          }
        } else {
          this.modalLoading = false;
        }
      });
    },
    async onClickRefresh() {
      this.spinShow = true;

      contract.loadStrategies();

      contract
        .loadVaults()
        .then((vaultList) => {
          this.vaultList = vaultList;
          this.loadVaultSt();
        })
        .catch((e) => {
          console.error("onClickRefresh: ", e);
        });

      this.loadTokenList();
    },

    async initStrategies(item, index) {
      const vault = new web3.eth.Contract(Vault, item.address);
      const strategy = new web3.eth.Contract(Strategy, item.address);

      Promise.all([
        vault.methods.strategy().call(),
        strategy.methods.strategyName().call({ from: window.currAddress }),
      ])
        .then(([strategyAddr, strategyName]) => {
          item.strategyAddr = strategyAddr;
          item.strategyName = strategyName;

          this.vaultList.splice(index, 1, item);
        })
        .catch((e) => {
          console.error("initStrategies: ", e);
        });
    },

    async initInvestTokens(item, index) {
      const strategy = new web3.eth.Contract(Strategy, item.address);

      this.investLoading = true;
      strategy.methods
        .investTokens()
        .call({ from: window.currAddress })
        .then(async (investTokens) => {
          item.investTokens = investTokens;

          const investTokenInfos = [],
            investTokenBalances = [],
            availableInvestTokenBalances = [],
            isInvestTokenApproveds = [];

          for (let investToken of investTokens) {
            // 添加
            this.onCreateToken(investToken);
            investTokenInfos.push(await contract.getERC20Info(investToken));
            investTokenBalances.push(
              await contract.getERC20BalanceOf(investToken, item.address)
            );
            let availableInvestTokenBalance = await contract.getERC20BalanceOf(
              investToken,
              window.currAddress
            );
            availableInvestTokenBalances.push(availableInvestTokenBalance);
            let allowance = await contract.getERC20Allowance(
              investToken,
              window.currAddress,
              item.address
            );
            isInvestTokenApproveds.push(
              new BigNumber(allowance).isGreaterThan(
                new BigNumber(availableInvestTokenBalance)
              )
            );
          }
          item.investTokenInfos = investTokenInfos;
          item.investTokenBalances = investTokenBalances;
          item.availableInvestTokenBalances = availableInvestTokenBalances;
          item.isInvestTokenApproveds = isInvestTokenApproveds;

          item.investedBalances = await strategy.methods
            .investedBalances()
            .call({ from: window.currAddress });

          item.withdrawInvestValues = new Array(item.investedBalances.length);

          this.vaultList.splice(index, 1, item);
        })
        .catch((e) => {
          console.error("initInvestTokens: ", e);
        })
        .finally(() => {
          this.investLoading = false;
        });
    },

    async initBorrowTokens(item, index) {
      const strategy = new web3.eth.Contract(Strategy, item.address);

      this.borrowLoading = true;
      strategy.methods
        .borrowTokens()
        .call({ from: window.currAddress })
        .then(async (borrowTokens) => {
          item.borrowTokens = borrowTokens;

          const borrowTokenInfos = [],
            borrowTokenBalances = [],
            availableBorrowTokenBalances = [],
            isBorrowTokenApproveds = [];

          for (let borrowToken of borrowTokens) {
            // 添加
            this.onCreateToken(borrowToken);
            borrowTokenInfos.push(await contract.getERC20Info(borrowToken));
            borrowTokenBalances.push(
              await contract.getERC20BalanceOf(borrowToken, item.address)
            );
            let availableBorrowTokenBalance = await contract.getERC20BalanceOf(
              borrowToken,
              window.currAddress
            );
            availableBorrowTokenBalances.push(availableBorrowTokenBalance);
            let allowance = await contract.getERC20Allowance(
              borrowToken,
              window.currAddress,
              item.address
            );
            isBorrowTokenApproveds.push(
              new BigNumber(allowance).isGreaterThan(
                new BigNumber(availableBorrowTokenBalance)
              )
            );
          }

          item.borrowTokenInfos = borrowTokenInfos;
          item.borrowTokenBalances = borrowTokenBalances;
          item.availableBorrowTokenBalances = availableBorrowTokenBalances;
          item.isBorrowTokenApproveds = isBorrowTokenApproveds;

          item.borrowedBalances = await strategy.methods
            .borrowedBalances()
            .call({ from: window.currAddress });

          this.refreshCount += 1;

          this.vaultList.splice(index, 1, item);
        })
        .catch((e) => {
          console.error("initBorrowTokens: ", e);
        })
        .finally(() => {
          this.borrowLoading = false;
        });
    },

    async initRewardTokens(item, index) {
      const strategy = new web3.eth.Contract(Strategy, item.address);

      this.rewardLoading = true;
      strategy.methods
        .rewardTokens()
        .call({ from: window.currAddress })
        .then(async (rewardTokens) => {
          item.rewardTokens = rewardTokens;

          const rewardTokenInfos = [],
            rewardTokenBalances = [];

          for (let rewardToken of rewardTokens) {
            // 添加
            this.onCreateToken(rewardToken);
            rewardTokenInfos.push(await contract.getERC20Info(rewardToken));
            rewardTokenBalances.push(
              await contract.getERC20BalanceOf(rewardToken, item.address)
            );
          }

          item.rewardTokenInfos = rewardTokenInfos;
          item.rewardTokenBalances = rewardTokenBalances;

          this.vaultList.splice(index, 1, item);
        })
        .catch((e) => {
          console.error("initRewardTokens: ", e);
        })
        .finally(() => {
          this.rewardLoading = false;
        });
    },

    async initClaimable(item, index) {
      const strategy = new web3.eth.Contract(Strategy, item.address);
      this.claimableLoading = true;
      strategy.methods
        .claim()
        .call({ from: window.currAddress })
        .then((claimable) => {
          item.claimable = claimable;
        })
        .catch((e) => {
          item.claimable = [0, 0];
          console.error("initClaimable: ", e);
        })
        .finally(() => {
          this.vaultList.splice(index, 1, item);

          this.claimableLoading = false;
        });
    },

    async initRiskIndex(item, index) {
      const strategy = new web3.eth.Contract(Strategy, item.address);
      this.riskLoading = true;
      strategy.methods
        .riskIndex()
        .call({ from: window.currAddress })
        .then((riskIndex) => {
          item.riskIndex = riskIndex["0"];
          this.vaultList.splice(index, 1, item);
        })
        .catch((e) => {
          console.error("initRiskIndex: ", e);
        })
        .finally(() => {
          this.riskLoading = false;
        });
    },

    loadVaultSt() {
      // this.spinShow = true;
      return new Promise((resolve, reject) => {
        if (this.vaultList.length === 0) {
          this.spinShow = false;
          return resolve();
        }
        this.vaultList.forEach(async (item, index) => {
          this.onResetBorrow(item, index);
          this.onResetRepay(item, index);
          let vault = new web3.eth.Contract(Vault, item.address);
          item.owner = await vault.methods.owner().call();

          item.isOwner = item.owner === window.currAddress;
          item.pendingOwner = await vault.methods.pendingOwner().call();

          item.isOperator =
            (await vault.methods.isOperator(window.currAddress).call()) ||
            item.isOwner;
          item.isHarvestor =
            (await vault.methods.isHarvestor(window.currAddress).call()) ||
            item.isOperator;

          item.isRelated =
            item.pendingOwner === window.currAddress || item.isHarvestor;

          this.$set(this.vaultList, index, item);
          if (!item.isRelated && !this.isOwner) return;
          this.haveRole = true;

          let strategy = new web3.eth.Contract(Strategy, item.address);

          this.initStrategies(item, index);
          this.initInvestTokens(item, index);
          this.initBorrowTokens(item, index);
          this.initRewardTokens(item, index);
          this.initClaimable(item, index);
          this.initRiskIndex(item, index);

          // item.strategyName = await strategy.methods
          //   .strategyName()
          //   .call({ from: window.currAddress });
          // item.investTokens = await strategy.methods
          //   .investTokens()
          //   .call({ from: window.currAddress });
          // item.borrowTokens = await strategy.methods
          //   .borrowTokens()
          //   .call({ from: window.currAddress });
          // item.rewardTokens = await strategy.methods
          //   .rewardTokens()
          //   .call({ from: window.currAddress });

          // let investTokenInfos = [],
          //   investTokenBalances = [],
          //   availableInvestTokenBalances = [],
          //   isInvestTokenApproveds = [];
          // let borrowTokenInfos = [],
          //   borrowTokenBalances = [],
          //   availableBorrowTokenBalances = [],
          //   isBorrowTokenApproveds = [];
          // let rewardTokenInfos = [],
          //   rewardTokenBalances = [];

          // for (let investToken of item.investTokens) {
          //   // 添加
          //   this.onCreateToken(investToken);
          //   investTokenInfos.push(await contract.getERC20Info(investToken));
          //   investTokenBalances.push(
          //     await contract.getERC20BalanceOf(investToken, item.address)
          //   );
          //   let availableInvestTokenBalance = await contract.getERC20BalanceOf(
          //     investToken,
          //     window.currAddress
          //   );
          //   availableInvestTokenBalances.push(availableInvestTokenBalance);
          //   let allowance = await contract.getERC20Allowance(
          //     investToken,
          //     window.currAddress,
          //     item.address
          //   );
          //   isInvestTokenApproveds.push(
          //     new BigNumber(allowance).isGreaterThan(
          //       new BigNumber(availableInvestTokenBalance)
          //     )
          //   );
          // }
          // item.investTokenInfos = investTokenInfos;
          // item.investTokenBalances = investTokenBalances;
          // item.availableInvestTokenBalances = availableInvestTokenBalances;
          // item.isInvestTokenApproveds = isInvestTokenApproveds;

          // for (let borrowToken of item.borrowTokens) {
          //   // 添加
          //   this.onCreateToken(borrowToken);
          //   borrowTokenInfos.push(await contract.getERC20Info(borrowToken));
          //   borrowTokenBalances.push(
          //     await contract.getERC20BalanceOf(borrowToken, item.address)
          //   );
          //   let availableBorrowTokenBalance = await contract.getERC20BalanceOf(
          //     borrowToken,
          //     window.currAddress
          //   );
          //   availableBorrowTokenBalances.push(availableBorrowTokenBalance);
          //   let allowance = await contract.getERC20Allowance(
          //     borrowToken,
          //     window.currAddress,
          //     item.address
          //   );
          //   isBorrowTokenApproveds.push(
          //     new BigNumber(allowance).isGreaterThan(
          //       new BigNumber(availableBorrowTokenBalance)
          //     )
          //   );
          // }

          // item.borrowTokenInfos = borrowTokenInfos;
          // item.borrowTokenBalances = borrowTokenBalances;
          // item.availableBorrowTokenBalances = availableBorrowTokenBalances;
          // item.isBorrowTokenApproveds = isBorrowTokenApproveds;

          // for (let rewardToken of item.rewardTokens) {
          //   // 添加
          //   this.onCreateToken(rewardToken);
          //   rewardTokenInfos.push(await contract.getERC20Info(rewardToken));
          //   rewardTokenBalances.push(
          //     await contract.getERC20BalanceOf(rewardToken, item.address)
          //   );
          // }

          // item.rewardTokenInfos = rewardTokenInfos;
          // item.rewardTokenBalances = rewardTokenBalances;
          // this.$set(this.vaultList, index, item);

          // try {
          //   item.claimable = await strategy.methods
          //     .claim()
          //     .call({ from: window.currAddress });
          // } catch (error) {
          //   item.claimable = [0, 0];
          //   console.log(error);
          // }

          // item.investedBalances = await strategy.methods
          //   .investedBalances()
          //   .call({ from: window.currAddress });
          // item.borrowedBalances = await strategy.methods
          //   .borrowedBalances()
          //   .call({ from: window.currAddress });
          // let riskIndex = await strategy.methods
          //   .riskIndex()
          //   .call({ from: window.currAddress });
          // item.riskIndex = riskIndex["0"];

          this.getVaultMaxLeverage(item, index);

          this.vaultList.splice(index, 1, item);

          if (index === 0) {
            this.spinShow = false;
            resolve();
          }

          console.log("vaultItem: ", item);
        });
      });
    },
    loadTokenList() {
      let tokenListMap = Store.get("tokenList") || {};
      let tokenList = tokenListMap[window.net] || [];
      this.tokenList = tokenList;
    },
    async onCreateToken(val) {
      val = tools.checkNoticeAddressValid(this, val);
      if (!val) {
        return;
      }

      let tokenListMap = Store.get("tokenList") || {};
      let tokenList = tokenListMap[window.net] || [];
      for (let token of tokenList) {
        if (token.address === val) {
          // item.withdrawToken = val
          return;
        }
      }
      let ercInfo = await contract.getERC20Info(val);
      ercInfo.address = val;
      tokenList.push(ercInfo);
      tokenListMap[window.net] = tokenList;
      Store.set("tokenList", tokenListMap);
      this.loadTokenList();
    },

    createVault(strategyAddr, vaultName) {
      this.custodyIndex.methods
        .createVault(strategyAddr, vaultName)
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.onClickRefresh();
            if (!error) {
              this.modalShow = false;
            }
          });
        });
    },
    editStrategy(strategyAddr, vaultAddr) {
      let vault = contract.getVault(vaultAddr);
      vault.methods
        .setStrategy(strategyAddr)
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt();
            if (!error) {
              this.modalShow = false;
            }
          });
        });
    },
    editVaultName(vaultName, vaultAddr) {
      this.custodyIndex.methods
        .renameVault(vaultAddr, vaultName)
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.onClickRefresh();
            if (!error) {
              this.modalShow = false;
            }
          });
        });
    },
    editVaultOwner(ownerAddr, vaultAddr) {
      let vault = contract.getVault(vaultAddr);
      vault.methods
        .proposeOwnership(ownerAddr)
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt();
            if (!error) {
              this.modalShow = false;
            }
          });
        });
    },
    onClickAcceptOwner(vaultAddr) {
      let vault = contract.getVault(vaultAddr);
      vault.methods
        .acceptOwnership()
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt();
          });
        });
    },

    async getTokenInfo(address, method) {
      return await contract.getERC20Info(address, method);
    },
    getStrategyName(stAddr) {},
  },
};
</script>

<style scoped>
.opRow {
  margin-top: 10px;
}
</style>

<style lang="scss" scoped>
@import "./index.module.scss";
</style>
